// Central support contact details. Reused by the error screen, soft-exit, and
// any future surface so the values live in one place.

export const SUPPORT_EMAIL = "support@benefits2.ca"
export const SUPPORT_PHONE = "1 877 257 7725"
// E.164 form for tel: links.
export const SUPPORT_PHONE_TEL = "+18772577725"
